<template>
  <v-dialog v-model="modalAjudaModel" max-width="900" scrollable persistent>
    <v-card v-if="ajudaSelecionada">
      <v-card-title class="green lighten-4 font-weight-bold primary--text"
        >{{ ajudaSelecionada.tituloModal }}</v-card-title
      >
      <v-progress-linear v-if="carregando"></v-progress-linear>
      <v-card-text v-else v-html="conteudo" class="mt-5 black--text">
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          min-width="80"
          max-height="30"
          @click="setModalAjuda(false)"
          rounded
          small
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";
export default {
  watch: {
    modalAjuda: async function (open) {
      if (open) {
        await this.getHelpTexto();
      }
    },
  },
  computed: {
    ...mapState("dependentes", ["modalAjuda", "ajudaSelecionada"]),
    modalAjudaModel: {
      get: function () {
        return this.modalAjuda;
      },
      set: function (value) {
        return this.setModalAjuda(value);
      },
    },
  },
  data: () => ({
    carregando: false,
    conteudo: "",
  }),
  methods: {
    ...mapMutations("dependentes", ["setModalAjuda"]),
    async getHelpTexto() {
      this.carregando = true;
      this.conteudo = "";
      await axios
        .get(`/colaborador/dependentes?funcao=${this.ajudaSelecionada.funcao}`)
        .then((res) => (this.conteudo = res.data));
      this.carregando = false;
    },
  },
};
</script>

<style>
</style>